import React from 'react';
import { clsx } from 'clsx';

const REPORT_TABS = [
  { id: 'availability', label: 'Availability Report' },
  { id: 'recall', label: 'Recall Report' },
] as const;

interface ReportSubTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const ReportSubTabs: React.FC<ReportSubTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="bg-slate-50 px-4 pt-4 pb-0">
      <div className="flex items-center gap-1">
        {REPORT_TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            data-tour={tab.id === 'recall' ? 'cpty-recall-subtab' : 'cpty-availability-subtab'}
            className={clsx(
              'px-8 py-3 text-sm font-medium transition-colors',
              activeTab === tab.id
                ? 'bg-white text-slate-900 font-semibold border-t border-x border-slate-200 rounded-t-lg -mb-[1px] relative z-10'
                : 'text-slate-500 bg-transparent rounded-md hover:bg-slate-200 hover:text-slate-800',
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
